import { createRouter, createWebHistory } from "vue-router";
import HomePage from "@/views/homePage.vue";
import secondaryHomePage from "@/views/secondaryHomePage.vue";
import VaccinationPage from "@/views/vaccinationPage.vue";
import pregHome from "@/views/pregnancyMainPage.vue";
import secondPregHome from "@/views/secondPregnancyPage.vue";
import adolescentsPage from "@/views/adolescentsPage.vue";
import secondAdolescentsPage from "@/views/secondAdolescentsPage.vue";
import oldPeoplePage from "@/views/oldPeoplePage.vue";
import oldPeopleSecondPage from "@/views/oldPeopleSeconedPage.vue";
import ImmunocompromisedPage from "@/views/ImmunocompromisedPage.vue";
import ImmunocompromisedSecondPage from "@/views/ImmunocompromisedSecondPage.vue";
import KidneyDiseases from "@/views/KidneyDiseases.vue";
import KidneyDiseasesSecond from "@/views/KidneyDiseasesSecond.vue";
import HIV from "@/views/HIV.vue";
import HIVSecondPage from "@/views/HIVSecondPage.vue";
import HeartDisease from "@/views/HeartDisease.vue";
import HeartDiseaseSecondPage from "@/views/HeartDiseaseSecondPage.vue";
import Diabetes from "@/views/DiabetesPage.vue";
import DiabetesSecondPage from "@/views/DiabetesSecondPage.vue";
import LungDisease from "@/views/LungDisease.vue";
import LungDiseaseSecondPage from "@/views/LungDiseaseSecondPage.vue";
import ChronicLiver from "@/views/ChronicLiver.vue";
import ChronicLiverSecondPage from "@/views/ChronicLiverSecondPage.vue";
import TravelingPage from "@/views/TravelingPage.vue";
import TravelingSecondPage from "@/views/TravelingSecondPage.vue";
import programPage from "@/views/programPage.vue";

const routes = [
  { path: "/", name: "Home", component: HomePage },
  { path: "/vaccination", name: "Vaccination", component: VaccinationPage },
  { path: "/pregHome", name: "pregHome", component: pregHome },
  {
    path: "/secondaryHomePage",
    name: "secondaryHomePage",
    component: secondaryHomePage,
  },

  {
    path: "/secondPregHome/:name",
    name: " secondPregHome",
    component: secondPregHome,
  },
  {
    path: "/adolescentsPage",
    name: "adolescentsPage",
    component: adolescentsPage,
  },
  {
    path: "/secondAdolescentsPage/:name",
    name: "secondAdolescentsPage",
    component: secondAdolescentsPage,
  },
  {
    path: "/oldPeoplePage",
    name: "oldPeoplePage",
    component: oldPeoplePage,
  },
  {
    path: "/oldPeopleSecondPage/:name",
    name: "oldPeopleSecondPage",
    component: oldPeopleSecondPage,
  },
  {
    path: "/ImmunocompromisedPage",
    name: "ImmunocompromisedPage",
    component: ImmunocompromisedPage,
  },
  {
    path: "/ImmunocompromisedSecondPage/:name",
    name: "ImmunocompromisedSecondPage",
    component: ImmunocompromisedSecondPage,
  },
  {
    path: "/KidneyDiseases",
    name: "KidneyDiseases",
    component: KidneyDiseases,
  },
  {
    path: "/KidneyDiseasesSecond/:name",
    name: "KidneyDiseasesSecond",
    component: KidneyDiseasesSecond,
  },
  {
    path: "/HIV",
    name: "HIV",
    component: HIV,
  },
  {
    path: "/HIVSecondPage/:name",
    name: "HIVSecondPage",
    component: HIVSecondPage,
  },
  {
    path: "/HeartDisease",
    name: "HeartDisease",
    component: HeartDisease,
  },
  {
    path: "/HeartDiseaseSecondPage/:name",
    name: "HeartDiseaseSecondPage",
    component: HeartDiseaseSecondPage,
  },
  {
    path: "/Diabetes",
    name: "Diabetes",
    component: Diabetes,
  },
  {
    path: "/DiabetesSecondPage/:name",
    name: "DiabetesSecondPage",
    component: DiabetesSecondPage,
  },
  {
    path: "/LungDisease",
    name: "LungDisease",
    component: LungDisease,
  },
  {
    path: "/LungDiseaseSecondPage/:name",
    name: "LungDiseaseSecondPage",
    component: LungDiseaseSecondPage,
  },
  {
    path: "/ChronicLiver",
    name: "ChronicLiver",
    component: ChronicLiver,
  },
  {
    path: "/ChronicLiverSecondPage/:name",
    name: "ChronicLiverSecondPage",
    component: ChronicLiverSecondPage,
  },
  {
    path: "/TravelingPage",
    name: "TravelingPage",
    component: TravelingPage,
  },
  {
    path: "/TravelingSecondPage/:name",
    name: "TravelingSecondPage",
    component: TravelingSecondPage,
  },
  {
    path: "/programPage",
    name: "programPage",
    component: programPage,
  },
  
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
